export default __webpack_public_path__ + "static/media/level.41528f49.png";